import { render, staticRenderFns } from "./NoticeImgDialog.vue?vue&type=template&id=1f1f432e&scoped=true&"
import script from "./NoticeImgDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeImgDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeImgDialog.vue?vue&type=style&index=0&id=1f1f432e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f432e",
  null
  
)

export default component.exports